import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const AlertDialog = ({
    open,
    handleClose,
    handleDelete,
    title = "Bạn có muốn xóa ý kiến này?",
}) => {
    return (
        <Dialog 
            open={open}
            onClose={handleClose}
            scroll={"paper"}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            className="doc-popup"
            fullWidth
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100vw",
                        maxWidth: "100vw", // Set your width here
                        mx: 0,
                    },
                },
            }}
        >
            <DialogTitle
                id="scroll-dialog-title"
                className="text-2xl font-bold text-[#23374D] !pt-8 min-h-[150px]"
                sx={{
                    fontWeight: 700,
                }}
            >
                <span className="font-bold">{title}</span>
            </DialogTitle>{" "}
            <DialogActions>
                <Button onClick={handleClose}>Không</Button>
                <Button sx={{ color: "red" }} onClick={handleDelete} autoFocus>
                    Xóa
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AlertDialog;
